import type { TFunction } from "i18next";

import type { LoadDictionaryField, ManifestField } from "@/api/integration";

type DocumentedField = Pick<LoadDictionaryField | ManifestField, "description" | "description_key">;
type ShapedField = Pick<
  LoadDictionaryField | ManifestField,
  "type" | "items" | "format" | "max_length" | "minimum"
>;

/** A descrição no idioma da tela; sem tradução, a do backend, em português. */
export function fieldDescription(t: TFunction, field: DocumentedField): string {
  return t(field.description_key, { defaultValue: field.description });
}

/** Tipo, formato e limites numa linha só. */
export function fieldShape(field: ShapedField): string {
  const base = field.type === "array" && field.items ? `array<${field.items}>` : field.type;
  const extras = [
    field.format,
    field.max_length !== undefined ? `≤ ${field.max_length}` : undefined,
    field.minimum !== undefined ? `≥ ${field.minimum}` : undefined,
  ].filter(Boolean);
  return extras.length ? `${base} · ${extras.join(" · ")}` : base;
}
